/** Capitalize the first letter and lowercase the rest for display. */
export function formatCategoryLabel(value: unknown): string {
  const label = String(value == null ? "" : value).trim().toLocaleLowerCase();
  return label.replace(/\p{L}/u, letter => letter.toLocaleUpperCase());
}
